<template>
  <div class="app-desktop-name-tooltip">
    <div class="form-tooltip__title">
      Формат ID товара:
    </div>
    <div v-for="item in items" class="form-tooltip__item">
      {{item}}
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductIdTooltip",
  data() {
    return {
      items: [
        'может содержать строчные латинские буквы',
        'может содержать цифры, точки и символы подчеркивания',
      ]
    }
  }
}
</script>

<style scoped>

</style>
